<template>
  <div v-if="visible" class="loading-bar" :class="{ 'loading-bar--done': done }"></div>
</template>

<script>
import router from '@/router';

export default {
  name: 'LoadingBar',
  data() {
    return {
      visible: false,
      done: false,
      timer: null
    };
  },
  mounted() {
    router.beforeEach(() => {
      this.start();
    });
    router.afterEach(() => {
      this.finish();
    });
  },
  methods: {
    start() {
      clearTimeout(this.timer);
      this.done = false;
      this.visible = true;
    },
    finish() {
      this.done = true;
      this.timer = setTimeout(() => {
        this.visible = false;
        this.done = false;
      }, 400);
    }
  }
};
</script>

<style scoped>
.loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  height: 2px;
  width: 0%;
  background: linear-gradient(90deg, #06b6d4, #67e8f9);
  z-index: 100;
  animation: loading-progress 2s ease-out forwards;
  box-shadow: 0 0 8px rgba(6, 182, 212, 0.6);
}

.loading-bar--done {
  width: 100% !important;
  animation: none;
  transition: opacity 0.3s ease;
  opacity: 0;
}

@keyframes loading-progress {
  0%   { width: 0%; }
  30%  { width: 40%; }
  60%  { width: 65%; }
  80%  { width: 80%; }
  100% { width: 90%; }
}
</style>
